export default {
  path: '/dashboard/',
  name: 'project.dashboard',
  meta: {
    title: 'Dashboard',
    layout: 'standard',
  },
  component: () => import('./DashboardPage.vue'),
};
